import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Apollo} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../../shared/redux-store/store";
import {SessionActions} from "../../../../shared/actions/session.actions";

@Component({
  selector: 'vb-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.css']
})
export class LogOutComponent implements OnInit {

  constructor(private router: Router,
              private ngRedux: NgRedux<IAppState>,
              private sessionActions: SessionActions,
              private apollo: Apollo) {
  }

  ngOnInit() {

    try {
      const queryManager = this.apollo && this.apollo.getClient() ? this.apollo.getClient().queryManager : null;

      for (let id in queryManager.queryStore.getStore()) {
        queryManager.stopQuery(id);
        queryManager.stopQueryInStore(id);
        queryManager.removeObservableQuery(id);
        queryManager.removeQuery(id);
      }

      this.ngRedux.dispatch({type: SessionActions.LOGOUT_USER});

      this.apollo.getClient().resetStore()
        .then(res => {
          this.router.navigate(['login']);
        })
        .catch(err => {
          this.sessionActions.throwError(err, "Fehler beim Ausloggen, bitte Laden Sie die Seite neu!");
          this.router.navigate(['login']);
        });
    } catch (err) {
      console.error("Error during log-out...", [err]);
      this.router.navigate(['login']);
    }


  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/log-out/log-out.component.ts